import * as React from 'react';

import {Card} from 'shells/card/card';
import {CollapsibleChevron} from 'shells/card/collapsible-chevron';
import {PeopleRegularIcon} from 'shells/icon';
import {Stack} from 'shells/layout/stack/stack';
import {CollapsibleStatBreakdown} from 'shells/metrics/collapsible-stat-breakdown/collapsible-stat-breakdown';

import type {Audience as AudienceFragment} from 'nutshell-graphql-types';

import {useGetAudienceMembershipDeltas} from '../graphql/hooks/use-get-audience-membership-deltas';

import {CollapsibleEmailStats} from './collapsible-email-stats';
import {CollapsibleSmsStats} from './collapsible-sms-stats';

type Props = {
    audience: AudienceFragment;
};

export function CurrentAudienceMembers(props: Props) {
    const [isCollapsed, setIsCollapsed] = React.useState(false);
    const {totalCountDelta, isLoading} = useGetAudienceMembershipDeltas(props.audience.id);

    const stats = props.audience.membershipStats;
    const totalCount = stats.totalCount.value;

    return (
        <Card hasBorder={true} fitContent={false} fitHeight={true}>
            <div
                className='pointer-cursor pos-relative pr-16'
                onClick={() => setIsCollapsed(!isCollapsed)}
            >
                <div className='pos-absolute right-16 top-16'>
                    <CollapsibleChevron isExpanded={!isCollapsed} />
                </div>
                <Stack spacing={16} isHorizontal={true}>
                    <CollapsibleStatBreakdown
                        isCollapsed={isCollapsed}
                        icon={PeopleRegularIcon}
                        title='Total members'
                        value={totalCount}
                        showChevron={false}
                        delta={
                            totalCountDelta
                                ? {
                                      percentChange: totalCountDelta.percentChange,
                                      timespanSuffix: totalCountDelta.timespanSuffix ?? '',
                                      changeType: totalCountDelta.direction,
                                  }
                                : undefined
                        }
                        isDeltaLoading={isLoading}
                        statsBreakdown={{
                            header: 'Current month stats',
                            details: [
                                {
                                    label: 'New',
                                    value: stats.newMembersCountCurrentMonth,
                                },
                                {
                                    label: 'Unsubscribed',
                                    value: stats.unsubscribedCountCurrentMonth,
                                },
                            ],
                        }}
                    />
                    <CollapsibleEmailStats stats={stats} isCollapsed={isCollapsed} />
                    <CollapsibleSmsStats audienceId={props.audience.id} isCollapsed={isCollapsed} />
                </Stack>
            </div>
        </Card>
    );
}
